import Api from '@/data/Api.ts';
import type Plant from '@/domain/model/business/Plant.ts';
import type Meter from '@/domain/model/business/Meter.ts';

const API_URL_YEARLY_PROGNOSIS = '/utilities/yearly-prognosis';

export default class PrognosisApi extends Api {
  yearlyPrognosis(plant: Plant, meter: Meter): Promise<any> {
    return this.standardGet(
      API_URL_YEARLY_PROGNOSIS,
      {
        peak_in_watt: meter.getPeakInWatt(),
        orientation_in_degrees: meter.getOrientationInDegrees(),
        angle_in_degrees: meter.getAngleInDegrees(),
        latitude: plant.getAddress().getLat(),
        longitude: plant.getAddress().getLng(),
      },
      [],
    );
  }
}
